import { Injectable } from '@angular/core';
import { ANALYTICS_EVENTS } from '../data-models/constants/analytics-extended.constant';
import {
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  USER_LOGGED_IN_STATUS
} from '../data-models/constants/analytics.constant';
import {
  AnalyticsSiteAssets,
  AnalyticsUser,
  ClickEventAnalytics
} from './analytics.interfaces';
import { ContentBodyAbodeExtendedAnalytics } from './content-body-extended-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class ContentBodyExtendedHelperAnalytics extends ContentBodyAbodeExtendedAnalytics {
  setHomePageSiteAssetsAnalytics(
    cardDiv: Element,
    eventDetail: string,
    customPosition?: string
  ): AnalyticsSiteAssets[] {
    if (!cardDiv) return [];
    const relevantElements = Array.from(
      cardDiv.querySelectorAll('h3, span, a')
    ).filter((element) => {
      const hasText = element.textContent?.trim();
      const isRelevantClass = [
        'card-headertxt',
        'card-title brand-head-home'
      ].includes(element.className);
      return hasText && isRelevantClass;
    });
    const component_type = this.getComponentName(eventDetail) || '';

    return relevantElements.map((element, index) => ({
      name: element.textContent?.trim() || '',
      type: component_type,
      position: customPosition || `${index + 1} of ${relevantElements.length}`,
      id: this.computePageLoadAssetID(component_type, index)
    }));
  }

  setLoginGlobalStatus(
    analyticsUser: AnalyticsUser,
    loginMethod: string
  ): void {
    const loggedIn = analyticsUser.attributes.is_logged_in;
    this.loginMethodUtil = loginMethod;
    const data: ClickEventAnalytics = {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: this.getLoggedInStatus(loggedIn),
      click: {
        name: this.getLoggedInStatus(loggedIn),
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: HEADER_MENU.GLOBAL_SEARCH.PAGE_SECTION,
        action: this.getLoggedInStatus(loggedIn)
      },
      user: {
        ...analyticsUser
      }
    };
    this.analyticsService.setAnalytics(data);
  }

  getLoggedInStatus(loggedInStatus: string): string {
    return loggedInStatus === USER_LOGGED_IN_STATUS.AUTHENTICATED
      ? USER_LOGGED_IN_STATUS.LOGIN_SUCCESS
      : USER_LOGGED_IN_STATUS.LOGIN_FAILURE;
  }

  getContentInfo(clickedElement: HTMLElement): {
    clicked: string;
    parent?: string;
  } {
    const clickedText = clickedElement.textContent?.trim() || '';

    const heroParent = this.getHeroParent(clickedElement, clickedText);
    if (heroParent) {
      return heroParent;
    }

    return this.getNonHeroParent(clickedElement, clickedText);
  }

  private getHeroParent(
    clickedElement: HTMLElement,
    clickedText: string
  ): { clicked: string; parent?: string } | null {
    const heroContainer = clickedElement.closest(
      '.d-flex.hero-home-text-container.flex-column'
    );
    if (!heroContainer) {
      return null;
    }

    const heroTitle =
      heroContainer
        .querySelector('.card-title.brand-head-home')
        ?.textContent?.trim() || '';
    return {
      clicked: clickedText,
      parent: clickedText === heroTitle ? undefined : heroTitle
    };
  }

  private getNonHeroParent(
    clickedElement: HTMLElement,
    clickedText: string
  ): { clicked: string; parent?: string } {
    const parentHeader =
      clickedElement
        .closest('a')
        ?.querySelector('.card-headertxt')
        ?.textContent?.trim() || '';
    return {
      clicked: clickedText,
      parent: clickedText === parentHeader ? undefined : parentHeader
    };
  }
}
